import { Component } from '@angular/core';

@Component({
  selector: 'redirect',
  templateUrl: './redirect-sso.component.html',
})

export class RedirectSSOComponent {}
